import React from 'react';

import Button from 'shared/ui/Button/Button/Button';
import {CreateEntityButton, useCreateGate} from 'entities/tariff';

import ExceededModal from '../ExceededModal/ExceededModal';

export interface ICreateGatedModalProps {
    open: boolean,
    handleClose: () => void,
}

export interface ICreateGatedButtonProps {
    label: string,
    canCreate: boolean,
    exceededType: React.ComponentProps<typeof ExceededModal>['type'],
    Modal: React.ComponentType<ICreateGatedModalProps>,
    variant?: 'entity' | 'transparent',
    disabled?: boolean,
    className?: string,
    onClick?: () => void,
}

const CreateGatedButton: React.FC<ICreateGatedButtonProps> = ({
    label,
    canCreate,
    exceededType,
    Modal,
    variant = 'entity',
    disabled,
    className,
    onClick,
}) => {
    const {open, close, isCreateOpen, isExceededOpen} = useCreateGate(canCreate);

    const handleClick = () => {
        onClick?.();
        open();
    };

    return (
        <>
            {variant === 'entity' ? (
                <CreateEntityButton
                    ariaLabel={label}
                    onClick={handleClick}
                    disabled={disabled}
                    className={className}
                >
                    {label}
                </CreateEntityButton>
            ) : (
                <Button
                    variant="transparent"
                    onClick={handleClick}
                    disabled={disabled}
                    className={className}
                >
                    {label}
                </Button>
            )}
            <ExceededModal isOpen={isExceededOpen} handleClose={close} type={exceededType}/>
            <Modal open={isCreateOpen} handleClose={close}/>
        </>
    );
};

export default CreateGatedButton;
